import React from 'react';
import './style.scss';

const Toast = (props) => {
    function hideToast() {
        console.log("hide toast clicked");
        (props?.onHide ?? (()=>{}))();
    }
    return (<div className="toastholder" onClick={hideToast}>
        <div className="toast">
            {props.children}
        </div>
    </div>);

}
export default Toast;